import { Grid, Link, Typography } from "@mui/material";
import React, { FC, PropsWithChildren } from "react";
import { COLORS } from "../styles/colors";

interface CopyrightProps extends PropsWithChildren {
  short?: boolean;
}

/**
 * The copyright component. If short flag is used, will not render GIS-OPS part (e.g. when using
 * it in the drawer).
 */
const Copyright: FC<CopyrightProps> = ({ short = false }) => {
  return (
    <Grid
      container
      flexDirection={short ? "column" : "row"}
      alignItems={"center"}
      spacing={short ? 0 : 0.5}
    >
      <Grid item>
        <Typography variant="caption" style={{ color: COLORS.tuv_r_black_30 }}>
          © {new Date().getFullYear()}{" "}
          <Link href="https://consulting.tuv.com" style={{ color: "inherit" }}>
            TÜV Rheinland Consoluting GmbH
          </Link>
          .
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="caption" style={{ color: COLORS.tuv_r_black_30 }}>
          Built with <span style={{ opacity: 0.4 }}>🖤</span> by{" "}
          <Link href="https://gis-ops.com" style={{ color: "inherit" }}>
            GIS-OPS
          </Link>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Copyright;
